import { useEffect, useState, useRef } from "react";
import { PlayerConfig, SourceConfig } from "bitmovin-player";
import { BitmovinPlayer } from "bitmovin-player-react";
import "bitmovin-player-ui/dist/css/bitmovinplayer-ui.css";
import { useApi } from '../../../../context/ApiContext/ApiContext';
import { Redo } from 'lucide-react';

const playerConfig = {
  key: "f7c712b2-e9c9-40bc-8e87-fe573b50fea0", // Replace with your valid Bitmovin Player license key
  playback: {
    muted: true,
    autoplay: true,
  },
  ui: {
    playback: {
      pictureInPicture: true,
    },
    container: undefined
  },
  style: {
    uxControls: true,
  }
};

// Add custom CSS for the blur effect
// const styles = `
//   .blurred-border {
//     position: relative;
//   }
  
//   .blurred-border::before {
//     content: "";
//     position: absolute;
//     top: -8px;
//     left: -8px;
//     right: -8px;
//     bottom: -8px;
//     z-index: -1;
//     background: rgba(59, 130, 246, 0.5); /* Blue with transparency */
//     filter: blur(10px);
//     border-radius: 12px;
//   }
  
//   /* Make the player responsive */
//   .bmpui-ui-container, 
//   .bmpui-ui-uicontainer, 
//   .bitmovinplayer-container,
//   .bitmovinplayer-container > div,
//   .bitmovinplayer-container > div > div {
//     width: 100% !important;
//     height: 100% !important;
//   }
  
//   /* Styles for reload button */
//   .player-reload-btn {
//     position: absolute;
//     top: 2px;
//     right: 2px;
//     z-index: 10;
//     background: rgba(0, 0, 0, 0.3);
//     border-radius: 50%;
//     width: 24px;
//     height: 24px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     cursor: pointer;
//     opacity: 0.5;
//     transition: opacity 0.2s ease;
//   }
  
//   .player-reload-btn:hover {
//     opacity: 1;
//   }
// `;

const SmartplayExamplesBitmovin2 = () => {
  const { state, updateSharedParams } = useApi();
  // const [bitmovinPlayerURL, setBitmovinPlayerURL] = useState({"hls": null});
  const [ bitmovinPlayerURL, setBitmovinPlayerURL ] = useState(undefined);
  const [ hasValidUrl, setHasValidUrl ] = useState(false);
  const [ playerKey, setPlayerKey ] = useState(Date.now()); // Used to force remount
  const playerRef = useRef(null);

  const PLAYER_DELAY_MS = 0;
  const [ showAfterDelay, setShowAfterDelay ] = useState(false);

  useEffect(() => {
    console.log("______________");
    console.log("hasValidUrl: ", hasValidUrl);
    console.log("state.sharedParams.playerURL: ", state.sharedParams.playerURL2);
    // console.log("state.sharedParams.isPlayerURLReady: ", state.sharedParams.isPlayerURLReady);
    console.log("______________");
  }, [hasValidUrl])
  
  // useEffect(() => {
  //   if (state.sharedParams?.playerURL2 && state.sharedParams.playerURL2.length > 0) {
  //     console.log('___state.playerURL2', state.sharedParams.playerURL2);
  //     const url = state.sharedParams.playerURL2;
  //     setBitmovinPlayerURL({ hls: url });
  //     setHasValidUrl(true);
  //   } else {
  //     setHasValidUrl(false);
  //   }
  // }, [state.sharedParams?.playerURL2]);
  useEffect(() => {
    // Check for players object with player2
    if (state.sharedParams?.players?.player2?.url) {
      console.log('___player2 URL', state.sharedParams.players.player2.url);
      const url = state.sharedParams.players.player2.url;
      setBitmovinPlayerURL({ hls: url });
      setHasValidUrl(true);
    } else {
      setHasValidUrl(false);
    }
  }, [state.sharedParams?.players]);

  
  // Ensure player is properly destroyed on unmount
  useEffect(() => {
    return () => {
      if (playerRef.current?.instance && !playerRef.current.instance.isDestroyed()) {
        playerRef.current.instance.destroy();
      }
    };
  }, []);
  
  // Function to reload the player by forcing a remount
  const handleReloadPlayer = () => {
    // First destroy the current instance if it exists
    if (playerRef.current?.instance && !playerRef.current.instance.isDestroyed()) {
      playerRef.current.instance.destroy();
    }
    
    // Generate a new key to force React to remount the component
    setPlayerKey(Date.now());
    
    // Log for debugging
    console.log('Player reloaded');
  };

  // In each player component, add this onPlayerLoaded event handler
  const onPlayerLoaded = (loadedPlayer) => {
    playerRef.current = loadedPlayer;
    
    // Add error handling for play/pause operations
    const originalPlay = loadedPlayer.play;
    loadedPlayer.play = function() {
      const playPromise = originalPlay.apply(this, arguments);
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          if (error.name !== 'AbortError') {
            console.error('Play error:', error);
          }
        });
      }
      return playPromise;
    };
  };
  

  // Add this useEffect for the delay
  useEffect(() => {
    if (hasValidUrl) {
      const timer = setTimeout(() => {
        setShowAfterDelay(true);
      }, PLAYER_DELAY_MS);
      
      return () => clearTimeout(timer);
    } else {
      setShowAfterDelay(false);
    }
  }, [hasValidUrl]);

  return (
    <>
      {/* <style>{styles}</style> */}
      
      <div 
        // className={`flex items-center justify-center blurred-border relative w-[330px] h-[190px] ${!hasValidUrl && !showAfterDelay ? "hidden" : "" } ? "hidden" : ""}`}
        // className={`flex items-center justify-center multiplayer-blurred-border relative w-[330px] h-[190px] ${!(hasValidUrl && showAfterDelay) ? "hidden" : ""}`}
        className={`flex items-center justify-center multiplayer-blurred-border relative w-[330px] h-[220px] ${!(hasValidUrl && showAfterDelay) ? "hidden" : ""}`}
      >
        {/* Reload button */}
        <div className="player-reload-btn" onClick={handleReloadPlayer}>
          <Redo size={16} color="#FFFFFF" />
        </div>
        
        <div className="w-full h-full">
          {hasValidUrl && showAfterDelay && (
            <>
              {/* <div className="w-full py-1 border-gray-700 bg-gray-900 text-gray-300 font-bold bg-opacity-80 rounded-t-2xl border-t">{'' || 'Player 2'}</div> */}
              <div className="w-full py-1 border-gray-700 bg-gray-900 text-gray-300 font-bold bg-opacity-80 rounded-t-2xl border-t">
                {state.sharedParams?.players?.player2?.title || 'Player 2'}
              </div>

              {/* <BitmovinPlayer 
                key={playerKey} // This forces React to remount when changed
                ref={playerRef}
                config={playerConfig} 
                source={bitmovinPlayerURL}
                style={{
                  width: '100%',
                  height: '100%'
                }}
              /> */}
              <BitmovinPlayer 
                key={playerKey}
                ref={playerRef}
                config={playerConfig} 
                source={bitmovinPlayerURL}
                onPlayerLoaded={onPlayerLoaded}
                style={{
                  width: '100%',
                  height: '100%'
                }}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SmartplayExamplesBitmovin2;



  // Add this helper function to each player component
  // const safePlay = (player) => {
  //   if (!player) return;
    
  //   // Store the play promise
  //   const playPromise = player.play();
    
  //   // If playPromise is defined (modern browsers)
  //   if (playPromise !== undefined) {
  //     playPromise.catch(error => {
  //       // Ignore AbortError when play is interrupted by pause
  //       if (error.name !== 'AbortError') {
  //         console.error('Playback error:', error);
  //       }
  //     });
  //   }
  // };